const isNullish = (prop: any): boolean => {
  if (prop === undefined || prop === null || prop === "") {
    return true;
  }
  if (Array.isArray(prop)) {
    return prop.filter((o) => o).length < 1;
  }
  if (typeof prop === "object") {
    return Object.keys(prop).length < 1;
  }
  return false;
};

export const removeEmptyProperties = <T>(obj: T): Partial<T> => {
  const partialObj: Partial<T> = {};
  const allPros: string[] = Object.keys(obj);
  allPros.forEach((prop) => {
    if (isNullish(obj[prop])) {
      return;
    }
    partialObj[prop] = obj[prop];
  });
  return partialObj;
};



// WEBPACK FOOTER //
// ./src/app/_helpers/remove-empy-properties.ts